import { createClient, fetchExchange } from '@urql/core'

/**
 * The browser's Staar CMS client: only the contact form's submission uses it (pages read
 * Craft on the server, lib/craft). Without the graphcache the Pages Router used, so the
 * 2.3 MB schema (graphql/schema.json) is no longer in the page's JavaScript.
 */
const defaultClient = createClient({
  url: process.env.NEXT_PUBLIC_EVO_GRAPHQL_URL ?? '',
  exchanges: [fetchExchange],
})

/**
 * Where the contact form posts its mutation instead of the CMS (undefined: the CMS). Vercel
 * previews (staging included) and development builds post to /api/sink/graphql (docs/forms.md);
 * any other build, including one that doesn't know its environment, posts to the CMS, so a
 * production build never drops submissions. NEXT_PUBLIC_EVO_FORM_SINK=true or false forces it.
 */
export const formSinkUrl = (): string | undefined => {
  const forced = process.env.NEXT_PUBLIC_EVO_FORM_SINK
  if (forced === 'true') return '/api/sink/graphql'
  if (forced === 'false') return undefined
  const env = process.env.NEXT_PUBLIC_VERCEL_ENV
  return env === 'preview' || env === 'development' ? '/api/sink/graphql' : undefined
}

export { defaultClient }
